export default __webpack_public_path__ + "static/chrome-60c68103ba76180a8ad561ebb006975d.png";